<template>
    <v-card>
        <v-card-title v-if="this.portfolioAllocator.id == null">Create Portfolio Allocator</v-card-title>
        <v-card-text>
            <v-row style="position: relative; margin-bottom: -20px;">
                <v-col cols="6">
                    Name *
                    <div class="tooltip-wrap" style="display: inline">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    style="display: inline"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="list-tooltip">
                                    <v-icon small>mdi-help-rhombus</v-icon>
                                </div>
                            </template>
                            <span>{{ tooltipText('Portal - Portfolio Allocator - Name') }}</span>
                        </v-tooltip>
                    </div>
                    <v-text-field
                        v-model="portfolioAllocator.name" @change="updateName"></v-text-field>
                </v-col>
                <v-col cols="6">
                    Portfolios *
                    <div class="tooltip-wrap" style="display: inline">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    style="display: inline"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="list-tooltip">
                                    <v-icon small>mdi-help-rhombus</v-icon>
                                </div>
                            </template>
                            <span>{{ tooltipText('Portal - Portfolio Allocator - Portfolio') }}</span>
                        </v-tooltip>
                    </div>
                    <v-select
                        @change="() => portfolioAllocator.risk_category = null"
                        v-model="portfolioAllocator.name_category"
                        :items="portfolioCategories"
                        ></v-select>
                </v-col>
                <v-col cols="6" v-if="!disableRisks">
                    Risk *
                    <div class="tooltip-wrap" style="display: inline">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    style="display: inline"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="list-tooltip">
                                    <v-icon small>mdi-help-rhombus</v-icon>
                                </div>
                            </template>
                            <span>{{ tooltipText('Portal - Portfolio Allocator - Risk') }}</span>
                        </v-tooltip>
                    </div>
                    <v-select
                        :items="riskOptions"
                        :disabled="disableRisks"
                        v-model="portfolioAllocator.risk_category"></v-select>
                </v-col>
                <v-col cols="6" v-if="portfolioAllocator.name_category">
                    <div>
                        Factsheet
                        <v-icon style="font-size: 15px; vertical-align: text-top;">mdi-file</v-icon>
                    </div>
                    <a
                        v-if="portfolioFileLink"
                        :href="portfolioFileLink"
                        target="_blank"
                        style="margin-top: 20px; display: block">
                        Link
                    </a>
                    <p v-else style="margin-top: 20px;">N/A</p>
                </v-col>

                <div class="pa-actions" style="">
                    <v-btn
                        v-if="portfolioAllocator.id"
                        :disabled="!savable"
                        class="secondary"
                        @click="save">Run Allocator</v-btn>
                    <v-btn
                        :disabled="!savable"
                        v-else
                        class="primary" @click="save">Save</v-btn>
                    <v-btn
                        v-if="this.portfolioAllocator.id"
                        class="error" @click="remove">Delete</v-btn>
                    <v-btn
                        v-else
                        class="secondary" @click="cancel">Cancel</v-btn>
                </div>
            </v-row>
        </v-card-text>

        <v-card-actions>

        </v-card-actions>
    </v-card>
</template>

<script>
import PortfolioAllocator from "@/store/models/PortfolioAllocator";
import {mapGetters, mapState} from "vuex";

export default {
    props: {
        portfolioAllocatorProp: {
            type: Object,
            required: false
        }
    },

    computed: {
        ...mapState('auth', ['portfolioCategories', 'user']),
        ...mapGetters('auth', [
            'getPortfolioCategoryRisks',
            'getPortfolioFileByCategoryAndRisk'
        ]),
        riskOptions() {
            return this.getPortfolioCategoryRisks(this.portfolioAllocator.name_category);
        },
        disableRisks() {
            return this.riskOptions?.length === 0 || this.portfolioAllocator.name_category == null;
        },
        savable() {
            return this.portfolioAllocator.name_category &&
                (this.portfolioAllocator.risk_category || this.riskOptions?.length === 0) &&
                this.portfolioAllocator.name &&
                !this.saving;
        },
        portfolioFileLink() {

            return this.getPortfolioFileByCategoryAndRisk(this.portfolioAllocator.name_category, this.portfolioAllocator.risk_category);
        }
    },

    inject: ['tooltipText'],

    data() {
        return {
            portfolioAllocator: new PortfolioAllocator(),
            saving: false
        }
    },

    mounted() {
        this.portfolioAllocator = this.portfolioAllocatorProp ? {...this.portfolioAllocatorProp} : new PortfolioAllocator({user_id: this.user.id});
    },

    methods: {
        save() {
            this.saving = true;
            let p = null;

            if (this.portfolioAllocator?.id) {
                let data = {
                    name_category: this.portfolioAllocator.name_category,
                    risk_category: this.portfolioAllocator.risk_category
                }

                if (this.portfolioAllocatorProp.name_category !== this.portfolioAllocator.name_category) {
                    data.allocations = null;
                }

                p = PortfolioAllocator.put(this.portfolioAllocator.id, data).then(() => {
                    this.$emit('run-allocator', this.portfolioAllocator)
                });
            } else {
                p = PortfolioAllocator.post(this.portfolioAllocator).then(() => {
                    this.$emit('portfolio-allocator-created');
                    this.portfolioAllocator = new PortfolioAllocator({user_id: this.user.id});
                })
            }

            p.finally(() => this.saving = false)
        },

        remove() {
            if (window.confirm(`Are you sure you want to delete ${this.portfolioAllocator.name} allocator?`)) {
                PortfolioAllocator.remove(this.portfolioAllocator.id);
            }
        },

        updateName() {
            if (this.portfolioAllocator.id) {
                PortfolioAllocator.put(this.portfolioAllocator.id, {name: this.portfolioAllocator.name});
            }
        },

        getNewAllocator() {
            return new PortfolioAllocator({user_id: this.user.id})
        },

        cancel() {
            this.$emit('portfolio-allocator-cancelled');
            this.portfolioAllocator = this.getNewAllocator();
        }
    }
}
</script>
